var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLetterButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#207945"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1631_1604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.1044 41.9922L43.0843 46.0259C41.4541 47.6618 38.5857 47.6971 36.9202 46.0259L32.8999 41.9922L18.4609 56.4781C18.9984 56.7266 19.591 56.8749 20.221 56.8749H59.7835C60.4135 56.8749 61.0059 56.7268 61.5432 56.4782L47.1044 41.9922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7832 23.125H20.2207C19.5907 23.125 18.9981 23.2733 18.4608 23.5218L33.8899 39.0021C33.891 39.0032 33.8922 39.0033 33.8932 39.0044C33.8938 39.005 33.8943 39.0059 33.8944 39.0068L38.9113 44.0403C39.4441 44.5731 40.56 44.5731 41.0928 44.0403L46.1086 39.0077C46.1086 39.0077 46.1099 39.0054 46.1109 39.0044C46.1109 39.0044 46.1131 39.0032 46.1142 39.0021L61.5429 23.5218C61.0056 23.2731 60.4132 23.125 59.7832 23.125ZM16.4506 25.4886C16.1726 26.0509 16.002 26.6751 16.002 27.3438V52.6562C16.002 53.3249 16.1724 53.9491 16.4505 54.5114L30.9146 40.0005L16.4506 25.4886ZM63.5533 25.4884L49.0894 40.0005L63.5533 54.5116C63.8313 53.9493 64.002 53.3251 64.002 52.6562V27.3438C64.002 26.6749 63.8313 26.0508 63.5533 25.4884Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1631_1604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(16.002 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterButton);
export default __webpack_public_path__ + "static/media/letterButton.e830ff2eb50291ae8d8c06386be192eb.svg";
export { ForwardRef as ReactComponent };